import React, { FC, useState } from 'react';
import InputComponent from '../../../core/components/input/InputComponent';
import { PanelSubSectionComponent } from '../../../core/components/oldPanel/OldPanelComponent';
import ButtonComponent from '../../../core/components/button/ButtonComponent';
import { useResetPassword } from '../useAuth';

type ResetPasswordContainerType = {
  onCloseModal: () => void;
};

export const ResetPasswordContainer: FC<ResetPasswordContainerType> = ({ onCloseModal }) => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState<string | undefined>();
  const [successMessage, setSuccessMessage] = useState<string | undefined>();
  
  const {
    isLoadingResetPassword, resetPasswordRequest, resetPasswordError, setResetPasswordError
  } = useResetPassword();

  const isValidEmail = email.includes('@') && email.includes('.');

  const onChangeEmail = (value: string) => {
    setEmail(value);
    if (emailError) {
      setEmailError(undefined);
    }
    if (resetPasswordError) {
      setResetPasswordError(undefined);
    }
    if (successMessage) {
      setSuccessMessage(undefined);
    }
  };

  const onRequestReset = async () => {
    try {
      await resetPasswordRequest(email);
      setSuccessMessage('Письмо с инструкциями по сбросу пароля отправлено на ваш email');
      setResetPasswordError(undefined);
    } catch (error) {
      if (error instanceof Error) {
        setResetPasswordError(error.message);
      }
      setSuccessMessage(undefined);
    }
  };

  return (
    <>
      <PanelSubSectionComponent>
        <p className="mb-[4px]">Введите email для сброса пароля:</p>
        <InputComponent 
          onChange={onChangeEmail} 
          value={email} 
          placeholder="Email" 
          errorText={emailError} 
        />
      </PanelSubSectionComponent>
      
      {resetPasswordError && <div className="text-danger text-14">{resetPasswordError}</div>}
      {successMessage && <div className="text-success text-14">{successMessage}</div>}
      
      <ButtonComponent
        className="mt-16"
        text="Отправить письмо"
        onClick={onRequestReset}
        isLoading={isLoadingResetPassword}
        isDisabled={isLoadingResetPassword || !isValidEmail}
      />
      
      {successMessage && (
        <ButtonComponent
          className="mt-8"
          text="Закрыть"
          onClick={onCloseModal}
          isOutline={true}
        />
      )}
    </>
  );
};